import React from 'react';
import PropTypes from 'prop-types';

export default class FieldCheckbox_FormCommon extends React.Component<any, any> {

    static propTypes = {
        className   : PropTypes.string,
        field       : PropTypes.object,
        disabled    : PropTypes.bool,

        value       : PropTypes.any, // boolean or number

        onChange    : PropTypes.func,
    }

    state = {
        value: this.props.value
    }

    componentDidUpdate(prevProps: Readonly<any>, prevState: Readonly<any>, snapshot?: any) {
        if (prevProps.value !== this.props.value) {
            this.setState({
                value: this.props.value
            })
        }
    }

    onClick = (e:React.SyntheticEvent) => {

        if (this.props.disabled) return

        const newValue = !this.state.value;
        this.setState({value: newValue}, ()=>{
            if (this.props.onChange) this.props.onChange(newValue);
        });
    }

    render() {
        let classes
        switch (this.props.field.renderType) {
            case 'circle'   :
                classes = Classes("ui5-todo-cb", "s-{0}".f(this.props.field.size), {
                    done: this.state.value
                })
                break

            case 'square'   :
            default         :
                classes = Classes("ui5-cb", "s-{0}".f(this.props.field.size), {
                    selected: this.state.value
                })
        }

        return (
            <div className={Classes("ui5-field-form-editable no-border transparent-bg min-h-36 p-l-10 p-r-10", this.props.className)}>
                <div className={classes} onClick={this.onClick}/>
            </div>
        )
    }
}